"use client";

import { FC } from "react";
import { useRouter } from "next/navigation";
import CustomButton from "@/components/uix/CustomButton/CustomButton";
import { RiDeleteBack2Fill } from "react-icons/ri";

interface TBackButtonProps {}

const BackButton: FC<TBackButtonProps> = (props: TBackButtonProps) => {
  const router = useRouter();

  return (
    <CustomButton
      onClick={() => router.back()}
      type='button'
      variant='secondary'
      className='h-2 p-2 py-3 bg-secondary/50 hover:bg-secondary'
    >
      <div className='flex items-center gap-1'>
        Retour <RiDeleteBack2Fill className='h-4 w-4' />
      </div>
    </CustomButton>
  );
};

export default BackButton;
